<template>
  <card class="summary-reports-card">
    <div class="flex jc-between md:fd-column">
      <div class="flex ai-center reports-season-items">
        <figure 
          class="p-x-2 m-y-2" 
          role="button" 
          v-for="(season, key) in seasons" :key="key"
          @click="seasonCurrent = season"
          :class="{'active': season.id == seasonCurrent.id}"
          >
          
          {{ season.title }}
          <!-- <small>{{ season.id }}</small> -->
        </figure>
      </div>
      <div class="flex ai-center">
        <div class="m-x-2">
          <button class="btn btn-sm btn-info" :disabled="disabled"
            @click="printContent('#report-table')">
            Печать
          </button>
        </div>
        <blob-download
          :url="'https://testback.avedu.uz/api/v3/schools/12/school_seasons/8/summary-report-export'" 
          :name="'Сводный отчёт о движении учеников'" 
          class="m-y-2"
          method="post"
          :params="{
              begin_date: this.begin_date, 
              end_date: this.end_date
          }">
          Выгрузить
        </blob-download>
      </div>
    </div>


    <div class="flex m-y-5 fd-column">
      <div class="m-b-3">
        Временной промежуток:
      </div>
      <div class="flex ai-center">
        <div class="flex ai-center m-x-2">
          <div class="m-r-2">
            с:
          </div>
          <datetime
            v-model="begin_date"
            class="from-control m-b-0"
            type="date"
            format="dd/MM/yyyy"
          ></datetime>
        </div>
        <div class="flex ai-center m-x-2">
          <div class="m-r-2">
            по:
          </div>
          <datetime
            v-model="end_date"
            class="from-control"
            type="date"
            format="dd/MM/yyyy"
          ></datetime>
        </div>
        <span class="btn-def m-l-4">
          <button @click="handleClick">Применить</button>
        </span>
      </div>
    </div>
    <div v-if="Object.keys(reports).length" id="report-table">
      <table class="table">
        <caption>Сводный отчёт о движении учеников</caption>
        <thead>
          <tr>
            <th>Параллель</th>
            <th>Начало периода</th>
            <th>Прибыло</th>
            <th>Выбыло</th>
            <th>Конец периода</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(report, key) in reports" :key="key" v-if="key != 'total'">
            <td>{{ key }}</td>
            <td>{{ report.beginning_count }}</td>
            <td>{{ report.admissions_count }}</td>
            <td>{{ report.exclusions_count }}</td>
            <td>{{ report.ending_count }}</td>
          </tr>
          <tr>
            <td><strong>Всего</strong></td>
            <td><strong>{{reports.total.total_beginning}}</strong></td>
            <td><strong>{{reports.total.total_admissions}}</strong></td>
            <td><strong>{{reports.total.total_exclusions}}</strong></td>
            <td><strong>{{reports.total.total_ending}}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="m-b-8 m-t-8 ta-center">
      Нет данных за выбранный период
    </div>
  </card>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
import { mapState } from "vuex";
export default {
  name: "SummaryReports",
  components: {
    "export-excel": () => import("@/components/ExportExcel"),
  },
  computed: {
    ...mapState(["seasons"]),
  },
  watch: {
    seasons(seasons){
      let season = seasons.filter((e)=>{return e.is_default == true})
      console.log('watch', seasons, season)
      if(season.length){
        this.seasonCurrent = season[0]
        this.begin_date = this.seasonCurrent.from_at
        this.end_date = this.seasonCurrent.till_at
      }
    },
    seasonCurrent(season){
      console.log('seasonCurrent watch', season)
      this.begin_date = season.from_at.split('T')[0]
      this.end_date = season.till_at.split('T')[0]
      this.handleClick()
    }
  },
  methods: {
    handleClick(){
      this.$loading(true);
      this.$http
        .get(`${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/school_seasons/${this.seasonCurrent.id}/summary-report`, {
          params:{
            begin_date: this.begin_date.split('T')[0],
            end_date: this.end_date.split('T')[0],
          }
        })
        .then((response) => {
          
          let total = {
            total_beginning : response.data.total_beginning,
            total_admissions : response.data.total_admissions,
            total_exclusions : response.data.total_exclusions,
            total_ending : response.data.total_ending,
          }
          response.data.total = total
          this.reports = response.data
          
          delete response.data.total_beginning
          delete response.data.total_admissions
          delete response.data.total_exclusions
          delete response.data.total_ending
          
          console.log(response.data)
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
    printContent(selector) {
      const content = document.querySelector(selector).innerHTML;
      const printWindow = window.open('', '');
      printWindow.document.write(`
        <html>
          <head><title>Сводка</title></head>
          <body>
            ${content}
            <br/>
            с: ${new Date(this.begin_date).toLocaleDateString()} 
            по: ${new Date(this.end_date).toLocaleDateString()}
          </body>
          <style>
            table{
              width: 100%;
              border: 1px solid #ccc;
            }
            caption{
              margin-bottom: 5px;
            }
            tr{
              color: #000000;
              background-color: aliceblue;
            }
            td{
              border-top: 1px solid #d1d1d1;
              padding: 4px 5px;
            }
          </style>
          
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  },
  mounted(){
    

    // console.log('this.seasonCurrent', this.seasons)
    
    // this.handleClick()
  },
  data() {
    return {
      seasonCurrent: {},
      begin_date: null,
      end_date: null,
      reports: {},
    };
  },
};
</script>
<style lang="scss">
  .summary-reports-card{
    .vdatetime-input{
      margin-bottom: 0;
    }
  }
  .reports-season-items{
    figure{
      background-color: #aaa;
      padding: 5px;
      margin: 5px;
      color: white;
      border-radius: 5px;
      &.active{
        background-color: #0097EE;
      }
    }
  }
</style>
